import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

// TikTok icon component (not in lucide-react)
const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-black text-white mt-24">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8">
          {/* Ayuda */}
          <div>
            <h3 className="text-[11px] font-bold uppercase tracking-[0.2em] mb-6 text-white">
              Ayuda
            </h3>
            <ul className="space-y-3 text-sm text-neutral-400">
              <li>
                <Link to="/track" className="hover:text-white transition-colors" data-testid="footer-track-link">
                  Seguir pedido
                </Link>
              </li>
              <li>
                <Link to="/devoluciones" className="hover:text-white transition-colors">
                  Devoluciones
                </Link>
              </li>
              <li>
                <Link to="/guia-tallas" className="hover:text-white transition-colors">
                  Guía de tallas
                </Link>
              </li>
              <li>
                <a href="mailto:infojrfsportswear@gmail.com" className="hover:text-white transition-colors">
                  Contacto email
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/34611871722"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>

          {/* Comprar */}
          <div>
            <h3 className="text-[11px] font-bold uppercase tracking-[0.2em] mb-6 text-white">
              Comprar
            </h3>
            <ul className="space-y-3 text-sm text-neutral-400">
              <li>
                <Link to="/mujer" className="hover:text-white transition-colors">
                  Mujer
                </Link>
              </li>
              <li>
                <Link to="/hombre" className="hover:text-white transition-colors">
                  Hombre
                </Link>
              </li>
              <li>
                <Link to="/accesorios" className="hover:text-white transition-colors">
                  Accesorios
                </Link>
              </li>
              <li>
                <Link to="/gift-cards" className="hover:text-white transition-colors">
                  Tarjetas regalo
                </Link>
              </li>
              <li>
                <Link to="/fidelidad" className="hover:text-white transition-colors">
                  Fidelidad
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-[11px] font-bold uppercase tracking-[0.2em] mb-6 text-white">
              Legal
            </h3>
            <ul className="space-y-3 text-sm text-neutral-400">
              <li>
                <Link to="/aviso-legal" className="hover:text-white transition-colors">
                  Aviso legal
                </Link>
              </li>
              <li>
                <Link to="/politica-privacidad" className="hover:text-white transition-colors">
                  Privacidad
                </Link>
              </li>
              <li>
                <Link to="/terminos-condiciones" className="hover:text-white transition-colors">
                  Términos
                </Link>
              </li>
              <li>
                <Link to="/politica-cookies" className="hover:text-white transition-colors">
                  Cookies
                </Link>
              </li>
            </ul>
          </div>

          {/* Síguenos */}
          <div>
            <h3 className="text-[11px] font-bold uppercase tracking-[0.2em] mb-6 text-white">
              Síguenos
            </h3>
            <div className="flex gap-4 mb-4">
              <a
                href="https://www.instagram.com/jrf_sportswear_"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-400 hover:text-white transition-colors"
                title="Instagram"
                data-testid="footer-instagram-link"
              >
                <Instagram className="w-5 h-5" strokeWidth={1.5} />
              </a>
              <a
                href="https://www.tiktok.com/@jrf_sportswear_"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-400 hover:text-white transition-colors"
                title="TikTok"
                data-testid="footer-tiktok-link"
              >
                <TikTokIcon className="w-5 h-5" />
              </a>
            </div>
            <p className="text-xs text-neutral-500 tracking-wide">@jrf_sportswear_</p>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-neutral-800">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-neutral-500 text-xs tracking-wide uppercase">
              © 2026 JRF Sportswear
            </p>
            <div className="flex items-center gap-2 text-xs text-neutral-500 tracking-wide uppercase">
              <span>Pago seguro</span>
              <span className="text-neutral-700">|</span>
              <span>Visa · Mastercard · PayPal · Apple Pay</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
